import { ICommandResult } from "../../../Common/domain/src/api/commandResult";
 
//RESEND CODE
export const RESEND_CODE = "RESEND_CODE";
export const RESEND_CODE_FAIL = "RESEND_CODE_FAIL";
export interface SetResendCodeState {
  result: ICommandResult;
}

export interface SetResendCodeType {
  type: typeof RESEND_CODE | typeof RESEND_CODE_FAIL;
  payload: ICommandResult;
}
export type ResendCodeType = SetResendCodeType;
